// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title_DQFOh","back":"Title_back_1sCYB"};